export enum LeagueTypeEnum {
    ROUNDROBIN = 'ROUND-ROBIN',
    TEAM = 'TEAM',
    MASTER = 'MASTER',
    ELIMINATION = 'ELIMINATION',
    SWISS = 'SWISS',
    DOUBLE_ELIMINATION = 'DOUBLE-ELIMINATION',
}

export const LeagueTypeFiltering = [
    {
        'value': LeagueTypeEnum.ROUNDROBIN,
        'label': 'Vòng tròn tính điểm',
    },
    {
        'value': LeagueTypeEnum.ELIMINATION,
        'label': 'Đấu loại trực tiếp',
    },
    {
        'value': LeagueTypeEnum.SWISS,
        'label': 'Swiss (loại theo mạng)',
    },
    /* Nhãn cho cơ thủ là "Đấu kép", đúng chuỗi mà backend trả về ở variantLabel - kiểu
       sơ đồ (Kiểu Việt Nam 2, kiểu quốc tế...) là chuyện của ban tổ chức. Thiếu dòng
       này thì NewListingItem tra không ra nhãn và thẻ giải Đấu kép trong danh sách
       không hiện thể thức nào cả. */
    {
        'value': LeagueTypeEnum.DOUBLE_ELIMINATION,
        'label': 'Đấu kép',
    },
]